module.exports = __webpack_public_path__ + "static/media/defaultAvatar8.f24efb27.svg";